import './polyfills.ts';
 import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { enableProdMode } from '@angular/core';
// import { environment } from './environments/environment';
 import { AppModule } from './app/';

// if (environment.production) {
//   enableProdMode();
// }
// let name = '';
// let trackingId = '';
// let hostname = document.location.hostname;
// for (let i = 0; i < environment.configmaxServiceBaseHost.length; i++) {
//   if (environment.configmaxServiceBaseHost[i].name.indexOf(hostname) !== -1) {
//     name = environment.configmaxServiceBaseHost[i].name;
//     trackingId = environment.configmaxServiceBaseHost[i].trackingId;
//   }
// }


// if (trackingId !== '') {
//   const script = document.createElement('script');
//   script.innerHTML =
  
//   `if (document.cookie.indexOf('OptanonConsent') > -1 && document.cookie.indexOf('groups=') > -1) {
//     if (decodeURIComponent(document.cookie).indexOf('C0002:1') > -1) {
//         if (/Selenium|LoadPass|PhantomJS/.test(navigator.userAgent)) {
//             // E2E Testing with Selenium: Disable tracking
//             window.ga = function () { };
//             window.s = undefined;
//         } else {
//             // Google Analytics Bootstrap
//             (function (i, s, o, g, r, a, m) {
//                 i['GoogleAnalyticsObject'] = r;
//                 i[r] = i[r] || function () {
//                     (i[r].q = i[r].q || []).push(arguments)
//                 },
//                     i[r].l = 1 * new Date();
//                 a = s.createElement(o), m = s.getElementsByTagName(o)[0]; a.async = 1;
//                 a.src = g;
//                 m.parentNode.insertBefore(a, m)
//             })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
//             ga('create', '` + trackingId + `', '`+ name +`');
//             ga('send', 'pageview');
//         }
//     }
//   }
//   else { waitForConsentCookie(); }
  
//   var waitForConsent;
  
//   function waitForConsentCookie() {
//     if (document.cookie.indexOf('OptanonConsent') > -1 && document.cookie.indexOf('groups=') > -1) {
//         clearTimeout(waitForConsent);
//         if (decodeURIComponent(document.cookie).indexOf('C0002:1') > -1) {
//             if (/Selenium|LoadPass|PhantomJS/.test(navigator.userAgent)) {
//                 // E2E Testing with Selenium: Disable tracking
//                 window.ga = function () { };
//                 window.s = undefined;
//             } else {
//                 // Google Analytics Bootstrap
//                 (function (i, s, o, g, r, a, m) {
//                     i['GoogleAnalyticsObject'] = r;
//                     i[r] = i[r] || function () {
//                         (i[r].q = i[r].q || []).push(arguments)
//                     },
//                         i[r].l = 1 * new Date();
//                     a = s.createElement(o), m = s.getElementsByTagName(o)[0]; a.async = 1;
//                     a.src = g;
//                     m.parentNode.insertBefore(a, m)
//                 })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
//                 ga('create', '` + trackingId + `', '`+ name +`');
//                 ga('send', 'pageview');
//             }
//         }
//     }
//     else { waitForConsent = setTimeout(waitForConsentCookie, 250); }
//   }`
//   script.type = "text/plain";
//   script.className = 'optanon-category-C0002';
//   document.head.appendChild(script);
  
// }

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts